import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Route, Redirect } from 'react-router-dom';
import authService from './api-authorization/AuthorizeService';
import { Stack, StackItem } from "@fluentui/react/lib/Stack";
import { Text, ITextProps } from '@fluentui/react/lib/Text';
import { Separator } from '@fluentui/react/lib/Separator';
import { DetailsList, DetailsListLayoutMode, Selection, IColumn, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { Link } from '@fluentui/react/lib/Link';
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { MessageBar, MessageBarType } from '@fluentui/react/lib/MessageBar';
import { MessageBarButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { ITheme, mergeStyleSets, getTheme, getFocusStyle } from '@fluentui/react/lib/Styling';
import { CommonModels } from "../models/CommonModels";
import { PivotLinkSize, PivotLinkFormat, PivotItem, Pivot } from '@fluentui/react/lib/Pivot';
import 'react-tabs/style/react-tabs.css';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { initializeIcons } from '@fluentui/react/lib/Icons';

const theme = getTheme();
let selectedKey = "f7Requests";
let token;

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/');

interface PortalHomeState {
    redirect: boolean,
    user?: any,
    referrals: Array<any>,
    requests: Array<any>,
    errorMessages: Array<string>,
    selectionCount: number,
    selection: Array<any>,
    filters: Array<CommonModels.KeyValuePair>,
    filterYear: number,
    noticeReferralFilter: number,
    requestFilter: number,
    defaultSelectedTab?: string,
    userFilters: Array<CommonModels.Filter>,
    showLoading: boolean,
    cancelledNotice: number,
    cancelledCase: number,
    cancelledDuplicate: number,
    cancelledTest: number,
    cancelledReferral: number,
    downloadFilesModalHidden: boolean,
    downloadableFiles: Array<any>,
    downloadableFilesLoaderHidden: boolean
}

const _columnsReferral = [
    { key: 'createdOn', name: 'Date Submitted', fieldName: 'createdOn', isResizable: true, minWidth: 75 },
    { key: 'pt_ConfirmationNoticeNumber', name: 'Confirmation Number', fieldName: 'pt_ConfirmationNoticeNumber', isResizable: true, minWidth: 95 },
    { key: 'pt_NContractNumber', name: 'Contract Number', fieldName: 'pt_NContractNumber', isResizable: true, minWidth: 75 },
    { key: 'pt_NoticeEmployer', name: 'Employer', fieldName: 'pt_NoticeEmployer', isResizable: true, minWidth: 150 },
    { key: 'pt_NBasisForComplaint', name: 'Basis for Complaint', fieldName: 'pt_NBasisForComplaint', isResizable: true, minWidth: 75 },
    { key: 'mediatorInfo', name: 'Assigned Mediator', fieldName: 'MediatorInfo', isResizable: true, minWidth: 150 },
    { key: 'pt_PublicStatus', name: 'Status', fieldName: 'pt_PublicStatus', isResizable: true, minWidth: 85 },
    { key: 'pt_DateClosedByRD', name: 'Date Closed', fieldName: 'pt_DateClosedByRD', isResizable: true, minWidth: 85 },
    { key: 'view', name: 'View', fieldName: 'value', isResizable: true, minWidth: 75 },
];
const _columnsF7Submission = [
    { key: 'createdOn', name: 'Date Submitted', fieldName: 'createdOn', isResizable: true, minWidth: 75 },
    { key: 'pt_ConfirmationNoticeNumber', name: 'Confirmation Number', fieldName: 'pt_ConfirmationNoticeNumber', isResizable: true, minWidth: 95 },
    { key: 'pt_NoticeEmployer', name: 'Employer', fieldName: 'pt_NoticeEmployer', isResizable: true, minWidth: 150 },
    { key: 'pt_NUnionAcronym', name: 'Union / Local', fieldName: 'pt_NUnionAcronym', isResizable: true, minWidth: 175 },
    { key: 'mediatorInfo', name: 'Assigned Mediator', fieldName: 'MediatorInfo', isResizable: true, minWidth: 150 },
    { key: 'pt_PublicStatus', name: 'Status', fieldName: 'pt_PublicStatus', isResizable: true, minWidth: 85 },
    { key: 'pt_DateClosedByRD', name: 'Date Closed', fieldName: 'pt_DateClosedByRD', isResizable: true, minWidth: 85 },
    { key: 'view', name: 'View', fieldName: 'value', isResizable: true, minWidth: 75 },
];

const _requestSubmission = [
    { key: 'createdOn', name: 'Date Submitted', fieldName: 'createdOn', isResizable: true, minWidth: 75 },
    { key: 'pt_ConfirmationNoticeNumber', name: 'Confirmation Number', fieldName: 'pt_ConfirmationNoticeNumber', isResizable: true, minWidth: 95 },
    { key: 'pt_NoticeEmployer', name: 'Employer', fieldName: 'pt_NoticeEmployer', isResizable: true, minWidth: 150 },
    { key: 'pt_NUnionAcronym', name: 'Union / Local', fieldName: 'pt_NUnionAcronym', isResizable: true, minWidth: 75 },
    { key: 'requestTypeShortName', name: 'Request Type', fieldName: 'requestTypeShortName', isResizable: true, minWidth: 75 },
    { key: 'mediatorInfo', name: 'Assigned Mediator', fieldName: 'MediatorInfo', isResizable: true, minWidth: 150 },
    { key: 'pt_PublicStatus', name: 'Status', fieldName: 'pt_PublicStatus', isResizable: true, minWidth: 85 },
    { key: 'pt_DateClosedByRD', name: 'Date Closed', fieldName: 'pt_DateClosedByRD', isResizable: true, minWidth: 85 },
    { key: 'view', name: 'View', fieldName: 'value', isResizable: true, minWidth: 75 },
];

const _downloadabledocumentColumns = [
    { key: 'pt_DocumentName', name: 'Document Name', fieldName: 'pt_DocumentName', isResizable: true, minWidth: 100 },
    { key: 'pt_DocumentType', name: 'Document Type', fieldName: 'pt_DocumentType', isResizable: true, minWidth: 325  },
    { key: 'DownloadLink', name: 'Document', fieldName: 'downloadLink', isResizable: true, minWidth: 100 },
];

export default class PortalHome extends React.Component<PortalHomeState> {
    state: PortalHomeState = {
        redirect: false,
        errorMessages: [],
        referrals: [],
        requests: [],
        selectionCount: 0,
        selection: [],
        filters: [],
        filterYear: 25,
        noticeReferralFilter: 25,
        requestFilter: 25,
        defaultSelectedTab: "f7Requests",
        userFilters: [],
        showLoading: false,
        cancelledNotice: 206300010,
        cancelledCase: 206300012,
        cancelledDuplicate: 206300013,
        cancelledTest: 206300014,
        cancelledReferral: 206300015,
        downloadFilesModalHidden: true,
        downloadableFiles: [],
        downloadableFilesLoaderHidden: true
    }

    public componentDidMount() {
        //debugger;
        console.log("PortalHome.tsx componentDidMount");
        this.getSecureData();
    }


    private async getSecureData() {

        token = await authService.getAccessToken();
        fetch('user', { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
            .then(response => response.status !== 204 ? response.json() : {})
            .then(dataUser => this.setState({ user: dataUser }))
            .then(() => { this.loadUserRecords(token) });
        //.then(dataUser => this.setState({ user: dataUser }, () => this.LoadUserFilterData(token)));

        const queryParams = new URLSearchParams(window.location.search);
        let showRequestsTxt = queryParams.get("showRequests");
        if (showRequestsTxt !== null && showRequestsTxt === "true") {
            this.setState({ defaultSelectedTab: "serviceRequests" });
        }
    }

    private async loadUserRecords(token) {
        console.log("in load UserRecords method")
        if (this.state.user?.isReferral == true) {
            //loads the user's referral records
            fetch('referralsubmissions?filter=' + this.state.noticeReferralFilter, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                .then(response => response.status !== 204 ? response.json() : [])
                .then(dataReferrals => this.setState({ referrals: dataReferrals }))
                .then(() => this.setState({ showLoading: true })); //, () => this.createDateFilters("Web Referral")));

            //load the user's filter data and create the filter object for Referrals
            fetch('filter', { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                .then(response => response.status !== 204 ? response.json() : [])
                .then(dataFilter => this.setState({ userFilters: dataFilter })) //, () => { console.log(this.state.userFilters);  this.createDateFilters()}));
                .then(() => { this.createDateFilters("Web Referral") });
        }
        else if (this.state.user?.isReferral == false) {
            //loads the user's F7 & Request data & creates the filter object and referrals
            fetch('f7submissions?filter=' + this.state.noticeReferralFilter, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                .then(response => response.status !== 204 ? response.json() : [])
                .then(dataReferrals => this.setState({ referrals: dataReferrals }))
                .then(() => this.setState({ showLoading: true })); //, () => this.createDateFilters("Web F7")));

            fetch('requestSubmissions?filter=' + this.state.requestFilter, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                .then(response => response.status !== 204 ? response.json() : [])
                .then(dataRequests => this.setState({ requests: dataRequests })); //, () => this.createDateFilters("Web Request")));

            //load the filter data and create the filter object for Notices (Since that is the default tab)
            fetch('filter', { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                .then(response => response.status !== 204 ? response.json() : [])
                .then(dataFilter => this.setState({ userFilters: dataFilter })) //, () => { console.log(this.state.userFilters);  this.createDateFilters()}));
                .then(() => { this.createDateFilters("Web F7") });
        }
    }



    private createDateFilters = (currentFormat: string): void => {
        //console.log("Create Data Filters");
        //console.log(this.state.userFilters.length);
        //console.log("Format: " + currentFormat);

        //if (this.state.defaultSelectedTab === "serviceRequests")
        //    console.log("Previous Selection: " + this.state.requestFilter);
        //else {
        //    //notice or referrals
        //    console.log("Previous Selection: " + this.state.noticeReferralFilter);
        //}


        let filterList: Array<CommonModels.KeyValuePair> = [{ key: "Past 25 Submissions", value: 25 }];

        //get the count of cases
        let caseCount = 0;

        //only sums up the case count for the given type we are looking at depending on the tab
        this.state.userFilters.forEach(a => {
            if (a.noticeFormat === currentFormat)
                caseCount += a.count;
        });

        if (caseCount > 25)
            filterList.push({ key: "Past 50 Submissions", value: 50 });

        if (caseCount > 50)
            filterList.push({ key: "Past 100 Submissions", value: 100 });

        this.state.userFilters.forEach(a => {
            if (a.noticeFormat === currentFormat)
                filterList.push({ key: a.label + " (" + a.count + ")", value: a.label });
        });

        this.setState({ filters: filterList });
    }

    private renderDropdownOption = (keyField: string, valueField: string, data: Array<any>): IDropdownOption[] => {
        let options: IDropdownOption[] = [];
        data.forEach(a => { options.push({ key: a[keyField], text: a[valueField] }); });
        return options;
    }

    private onChangeDropdown = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined): void => {
        this.setState({ filterYear: option?.key });
        this.setState({ showLoading: false });
        console.log("Filter Changed: " + this.state.defaultSelectedTab);

        if (this.state.user?.isReferral === true) {
            this.setState({ noticeReferralFilter: option?.key });

            fetch('referralsubmissions?filter=' + option?.key, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                .then(response => response.status !== 204 ? response.json() : [])
                .then(dataReferrals => this.setState({ referrals: dataReferrals }))
                .then(() => this.setState({ showLoading: true }));
        }
        else {
            //Notice Side
            if (this.state.defaultSelectedTab === "f7Requests") {
                this.setState({ noticeReferralFilter: option?.key });

                //get the F7s
                fetch('f7submissions?filter=' + option?.key, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                    .then(response => response.status !== 204 ? response.json() : [])
                    .then(dataReferrals => this.setState({ referrals: dataReferrals }))
                    .then(() => this.setState({ showLoading: true }));
            }
            else {
                //Get the requests
                this.setState({ requestFilter: option?.key });

                fetch('requestSubmissions?filter=' + option?.key, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                    .then(response => response.status != 204 ? response.json() : [])
                    .then(dataRequests => this.setState({ requests: dataRequests }))
                    .then(() => this.setState({ showLoading: true }));
            }
        }
    };

    private onPivotChange = (item?: PivotItem, ev?: React.MouseEvent<HTMLElement>): void => {
        this.setState({ defaultSelectedTab: item?.props.itemKey });

        console.log("Pivot Changed: " + item?.props.itemKey);
        console.log("Selected Tab: " + this.state.defaultSelectedTab);

        //updates the filters for the new data we are looking at since the tab was changed
        if (item?.props.itemKey === "f7Requests")
            this.createDateFilters("Web F7");
        else if (item?.props.itemKey === "serviceRequests")
            this.createDateFilters("Web Request");
        else
            this.createDateFilters("Web Referral");
    };

    private _selection = new Selection({
        onSelectionChanged: () => this.setState({ selectionCount: this._selection.getSelectedCount(), selection: this._selection.getSelection() }),
    });

    //private getFilteredData = (data: Array<any>, filterYear: number): Array<any> => {
    //    return data.filter(f => filterYear == -1 || new Date(f.createdOn).getFullYear() === filterYear);
    //}


    private async downloadAnnotation(id: string, caller: string) {
        const token = await authService.getAccessToken();
        window.open(`annotations?id=${id}&token=${encodeURIComponent(token)}&caller=${caller}`);
    }

    private renderDownloadableDocumentColumn = (item: any, index: number, column: IColumn): JSX.Element => {
        const fieldContent = item[column.fieldName] as string;
        if (column.key == 'DownloadLink') {
            return <div><small><Link onClick={() => this.downloadAnnotation(item.downloadLink,'referral')} target="_blank">Download</Link></small></div>;
        }
        else
            return <span>{fieldContent}</span>;
    }

    private showDocuments(id: string) {
        this.setState({ downloadableFilesLoaderHidden: false });

        const requestOptions = {
            method: 'GET'
        };

        fetch('DocMan?fmcsCaseID=' + id, requestOptions).then(response => response.json())
            .then((responseText) => this.setState({ downloadableFiles: responseText }))
            .then(() => { this.setState({ downloadableFilesLoaderHidden: true }) });

        this.setState({ downloadFilesModalHidden: false });
    }

    private renderItemColumn = (item: any, index: number, column: IColumn): JSX.Element => {
        const fieldContent = item[column.fieldName] as string;

        switch (column.key) {
            case 'view':
                let linkName = "F7 NOTICE";
                let sourceFileCreated = false;

                if (this.state.user?.isReferral === true) {
                    linkName = "REFERRAL";
                    sourceFileCreated = item.pt_SourceReferralCreated;

                    if (sourceFileCreated) {
                        if (item.additionalNoticeId != undefined) {
                            //downloadFilesModalHidden
                            //return <div><small><Link onClick={() => this.downloadAnnotation(item.id)} target="_blank">{linkName}</Link><br /><Link onClick={() => this.downloadAnnotation(item.additionalNoticeId)} target="_blank">ADDL NOTICES</Link></small></div>;
                            return <div><small><Link onClick={() => this.showDocuments(item.id)}>Documents</Link><br /></small></div>;
                        }
                        else {
                            //return <div><small><Link onClick={() => this.downloadAnnotation(item.id)} target="_blank">{linkName}</Link></small></div>;
                            return <div><small><Link onClick={() => this.showDocuments(item.id)}>Documents</Link><br /></small></div>;
                        }
                    }
                }
                else {
                    sourceFileCreated = item.pt_sourceF7Created;

                    if (sourceFileCreated) {
                        //todo: need to query for all files and then return markup to the below collection.

                        //bindable data collection of all the documents that are available to download.
                        //Collection: downloadableFiles

                        //-- 12/13 - Swapped the below lines for testing.
                        if (item.additionalNoticeId != undefined) {
                            //downloadFilesModalHidden
                            return <div><small><Link onClick={() => this.downloadAnnotation(item.id, "notice")} target="_blank">{linkName}</Link><br /><Link onClick={() => this.downloadAnnotation(item.additionalNoticeId, "notice")} target="_blank">ADDL NOTICES</Link></small></div>;
                            //return <div><small><Link onClick={() => this.showDocuments(item.id)}>Documents</Link><br /></small></div>;
                        }
                        else {
                            return <div><small><Link onClick={() => this.downloadAnnotation(item.id, "notice")} target="_blank">{linkName}</Link></small></div>;
                            //return <div><small><Link onClick={() => this.showDocuments(item.id)}>Documents</Link><br /></small></div>;
                        }
                    }
                }

                return;
            case 'pt_NoticeUnionContact':
                if (item.pt_NoticeUnionContact !== undefined) {
                    return <span title={item.pt_NoticeUnionContact}>{item.pt_NoticeUnionContact}</span>
                }
                else
                    return <span></span>

            case 'pt_NUnionAcronym':
                if (item.pt_NoticeUnion !== undefined) {
                    return <span title={item.pt_NUnionAcronym + " " + item.nUnionLocal}>{item.pt_NUnionAcronym} {item.nUnionLocal}</span>
                }
                else
                    return <span></span>
            case 'pt_NoticeEmployer':
                if (item.pt_NoticeEmployer !== undefined) {
                    return <span title={item.pt_NoticeEmployer}>{item.pt_NoticeEmployer}</span>
                }
                else
                    return <span></span>
            case 'pt_NBasisForComplaint':
                if (item.pt_NBasisForComplain !== undefined) {
                    return <span title={item.pt_NBasisForComplaint}>{item.pt_NBasisForComplaint}</span>
                }
                else
                    return <span></span>
            case 'mediatorInfo':
                if (item.mediatorInfo !== undefined && item.mediatorInfo.name !== undefined && item.mediatorInfo.name != "" && item.statusCodeValue != this.state.cancelledCase &&
                    item.statusCodeValue != this.state.cancelledDuplicate && item.statusCodeValue != this.state.cancelledNotice && item.statusCodeValue != this.state.cancelledReferral && item.statusCodeValue != this.state.cancelledTest) {
                    return <span title={item.mediatorInfo.name}>{item.mediatorInfo.name}<br /><small><a href={"mailto:" + item.mediatorInfo.email}>{item.mediatorInfo.email}</a><br />{item.mediatorInfo.phone}</small></span>;
                }
                else {
                    return <span></span>
                }
            case 'pt_PublicStatus':
                if (item.pt_PublicStatus !== undefined) {
                    return <span title={item.pt_PublicStatus}>{item.pt_PublicStatus}</span>
                }
                else
                    return <span></span>
            case 'createdOn':
                let localDate: Date = new Date(item[column.fieldName]);
                let month = '' + (localDate.getMonth() + 1);
                let day = '' + localDate.getDate();
                let year = localDate.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                return <span>{[year, month, day].join('-')}</span>;
            default:
                return <span>{fieldContent}</span>;
        }
    }

    private renderRequesItemColumn = (item: any, index: number, column: IColumn): JSX.Element => {
        const fieldContent = item[column.fieldName] as string;

        switch (column.key) {
            case 'view':
                let linkName = "REQUEST";
                let sourceFileCreated = false;
                sourceFileCreated = item.pt_sourceF7Created;

                if (sourceFileCreated) {
                    return <div><small><Link onClick={() => this.downloadAnnotation(item.id, "request")} target="_blank">{linkName}</Link></small></div>;
                }

                return;
            case 'pt_NoticeUnionContact':
                if (item.pt_NoticeUnionContact !== undefined) {
                    return <span title={item.pt_NoticeUnionContact}>{item.pt_NoticeUnionContact}</span>
                }
                else
                    return <span></span>
            case 'pt_NUnionAcronym':
                if (item.pt_NoticeUnion !== undefined) {
                    return <span title={item.pt_NUnionAcronym + " " + item.nUnionLocal}>{item.pt_NUnionAcronym} {item.nUnionLocal}</span>
                }
                else
                    return <span></span>
            case 'pt_NoticeEmployer':
                if (item.pt_NoticeEmployer !== undefined) {
                    return <span title={item.pt_NoticeEmployer}>{item.pt_NoticeEmployer}</span>
                }
                else
                    return <span></span>
            case 'requestTypeShortName':
                if (item.requestTypeShortName !== undefined) {
                    return <span title={item.requestTypeShortName}>{item.requestTypeShortName}</span>
                }
                else
                    return <span></span>
            case 'pt_NBasisForComplaint':
                if (item.pt_NBasisForComplain !== undefined) {
                    return <span title={item.pt_NBasisForComplaint}>{item.pt_NBasisForComplaint}</span>
                }
                else
                    return <span></span>
            case 'mediatorInfo':
                if (item.mediatorInfo !== undefined && item.mediatorInfo.name !== undefined && item.mediatorInfo.name !== "" && item.statusCodeValue != this.state.cancelledCase &&
                    item.statusCodeValue != this.state.cancelledDuplicate && item.statusCodeValue != this.state.cancelledNotice && item.statusCodeValue != this.state.cancelledReferral && item.statusCodeValue != this.state.cancelledTest) {
                    return <span title={item.mediatorInfo.name}>{item.mediatorInfo.name}<br /><small><a href={"mailto:" + item.mediatorInfo.email}>{item.mediatorInfo.email}</a><br />{item.mediatorInfo.phone}</small></span>;
                }
                else {
                    return <span></span>
                }
            case 'pt_PublicStatus':
                if (item.pt_PublicStatus !== undefined) {
                    return <span title={item.pt_PublicStatus}>{item.pt_PublicStatus}</span>
                }
                else
                    return <span></span>
            case 'createdOn':
                let localDate: Date = new Date(item[column.fieldName]);
                let month = '' + (localDate.getMonth() + 1);
                let day = '' + localDate.getDate();
                let year = localDate.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                return <span>{[year, month, day].join('-')}</span>;
            default:
                return <span>{fieldContent}</span>;
        }
    }

    private _onItemInvoked = (item: any): void => {
        console.log(item);
    };

    private DownloadableDocumentsDismissed = () => {
        this.setState({ downloadFilesModalHidden: true });
        this.setState({ downloadableFiles: [] });
    }

    public render() {

        const { user, redirect } = this.state;

        //force the user to enter a contract if its null
        if (user !== undefined && user.isReferral && user.contract === null) {
            return (<Redirect to={`/Contract`} />);
        }

        if (redirect) {
            return (<Redirect to='/Contract' />);
        }

        return (
            <div>
                <div style={{ display: this.state.user !== undefined && this.state.user?.isReferral == true ? "block" : "none" }}>
                    <MessageBar messageBarType={MessageBarType.success} isMultiline={false}
                        actions={
                            <div>
                                <MessageBarButton onClick={e => this.setState({ redirect: true })}>Change Contract</MessageBarButton>
                            </div>
                        }>
                        You are submitting referrals for contract <strong>{this.state.user?.contract?.name}</strong>.
                    </MessageBar>
                </div>

                <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px", display: this.state.user != undefined ? "none" : "block" }}>
                    <Text variant={"xLarge" as ITextProps['variant']}>Welcome</Text>
                    <Separator alignContent="start"></Separator>
                    <Stack>
                        <StackItem>
                            <p>Use of online processing provides the submitting party with immediate written confirmation, whereas sending via mail or other paper delivery will cause delays and we will not be able to confirm receipt. If you need to submit multiple notices, you may do that online. If you need further assistance, please call 202-606-5499 or 202-606-5496. We greatly appreciate your cooperation.</p>

                        </StackItem>
                    </Stack>
                </div>
                <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px", display: this.state.user != undefined ? "block" : "none" }}>
                    <Text variant={"xLarge" as ITextProps['variant']}>Welcome {this.state.user?.name}</Text>
                    <Separator alignContent="start"></Separator>
                    <Stack>
                        <StackItem>
                            <p>Use of online processing provides the submitting party with immediate written confirmation, whereas sending via mail or other paper delivery will cause delays and we will not be able to confirm receipt. If you need to submit multiple notices, you may do that online. If you need further assistance, please call {this.state.user != undefined && this.state.user?.isReferral == true ? "(202) 606-5445" : "(202) 606-5499"}. We greatly appreciate your cooperation.</p>
                            <div style={{ display: this.state.user != undefined && this.state.user?.isReferral == true ? "block" : "none" }}><p>Note: The Date Closed in the listing of referral submissions below represents the date the work of the submitted case is closed, but not its related billing status dates.</p></div>
                        </StackItem>
                    </Stack>
                </div>
                <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px", display: this.state.user != undefined && this.state.user?.isReferral == false ? "block" : "none" }}>
                    <Pivot selectedKey={this.state.defaultSelectedTab} onLinkClick={this.onPivotChange} >
                        <PivotItem headerText="My F7 Notice Submissions" itemKey="f7Requests" >
                            <Stack horizontal>
                                <StackItem grow>
                                    <Text variant={"large" as ITextProps['variant']}>    </Text>
                                </StackItem>
                                <StackItem shrink>
                                    <Dropdown dropdownWidth={200} selectedKey={this.state.noticeReferralFilter} options={this.renderDropdownOption("value", "key", this.state.filters)} onChange={this.onChangeDropdown} />
                                </StackItem>
                            </Stack>
                            <Separator alignContent="start"></Separator>
                            <Stack>
                                <StackItem hidden={this.state.showLoading}>
                                    <Spinner label="Loading Notice Records ..." ariaLive="assertive" labelPosition="right" />
                                </StackItem>
                                <StackItem>
                                    <DetailsList
                                        items={this.state.referrals} //{this.getFilteredData(this.state.referrals, this.state.filterYear)}
                                        columns={_columnsF7Submission}
                                        setKey="set"
                                        layoutMode={DetailsListLayoutMode.justified}
                                        selection={this._selection}
                                        selectionPreservedOnEmptyClick={true}
                                        selectionMode={SelectionMode.none}
                                        onRenderItemColumn={this.renderItemColumn}
                                        ariaLabelForSelectionColumn="Toggle selection"
                                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                        checkButtonAriaLabel="select row"
                                        onItemInvoked={this._onItemInvoked}
                                        onRenderDetailsHeader={(headerProps, defaultRender) => {
                                            return defaultRender({
                                                ...headerProps,
                                                styles: {
                                                    root: {
                                                        selectors: {
                                                            '.ms-DetailsHeader-cell': {
                                                                whiteSpace: 'normal',
                                                                textOverflow: 'clip',
                                                                lineHeight: 'normal',
                                                            },
                                                            '.ms-DetailsHeader-cellTitle': {
                                                                height: '100%',
                                                                alignItems: 'center',
                                                            },
                                                        },
                                                    }
                                                }
                                            })
                                        }}
                                    />
                                </StackItem>
                            </Stack>
                        </PivotItem>
                        <PivotItem headerText="My Service Request Submissions" itemKey="serviceRequests" >
                            <Stack horizontal>
                                <StackItem grow>
                                    <Text variant={"large" as ITextProps['variant']}>    </Text>
                                </StackItem>
                                <StackItem shrink>
                                    <Dropdown selectedKey={this.state.requestFilter} options={this.renderDropdownOption("value", "key", this.state.filters)} onChange={this.onChangeDropdown} />
                                </StackItem>
                            </Stack>

                            <Separator alignContent="start"></Separator>
                            <Stack>
                                <StackItem hidden={this.state.downloadableFilesLoaderHidden}>
                                    <Spinner label="Loading Request Records ..." ariaLive="assertive" labelPosition="right" />
                                </StackItem>
                                <StackItem>
                                    <DetailsList
                                        items={this.state.requests} //{this.getFilteredData(this.state.requests, this.state.filterYear)}
                                        columns={_requestSubmission}
                                        setKey="set"
                                        layoutMode={DetailsListLayoutMode.justified}
                                        selection={this._selection}
                                        selectionPreservedOnEmptyClick={true}
                                        selectionMode={SelectionMode.none}
                                        onRenderItemColumn={this.renderRequesItemColumn}
                                        ariaLabelForSelectionColumn="Toggle selection"
                                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                        checkButtonAriaLabel="select row"
                                        onItemInvoked={this._onItemInvoked}
                                        onRenderDetailsHeader={(headerProps, defaultRender) => {
                                            return defaultRender({
                                                ...headerProps,
                                                styles: {
                                                    root: {
                                                        selectors: {
                                                            '.ms-DetailsHeader-cell': {
                                                                whiteSpace: 'normal',
                                                                textOverflow: 'clip',
                                                                lineHeight: 'normal',
                                                            },
                                                            '.ms-DetailsHeader-cellTitle': {
                                                                height: '100%',
                                                                alignItems: 'center',
                                                            },
                                                        },
                                                    }
                                                }
                                            })
                                        }}
                                    />
                                </StackItem>
                            </Stack>
                        </PivotItem>
                    </Pivot>
                </div>
                <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px", display: this.state.user != undefined && this.state.user?.isReferral == true ? "block" : "none" }}>
                    <Stack horizontal>
                        <StackItem grow>
                            <Text variant={"xLarge" as ITextProps['variant']}>My Referral Submissions</Text>
                        </StackItem>
                        <StackItem shrink>
                            <Dropdown selectedKey={this.state.noticeReferralFilter} options={this.renderDropdownOption("value", "key", this.state.filters)} onChange={this.onChangeDropdown} />
                        </StackItem>
                    </Stack>
                    <Separator alignContent="start"></Separator>
                    <Stack>
                        <StackItem hidden={this.state.showLoading}>
                            <Spinner label="Loading Referral Records ..." ariaLive="assertive" labelPosition="right" />
                        </StackItem>
                        <StackItem>
                            <DetailsList
                                items={this.state.referrals} //{this.getFilteredData(this.state.referrals, this.state.filterYear)}
                                columns={_columnsReferral}
                                setKey="set"
                                layoutMode={DetailsListLayoutMode.justified}
                                selection={this._selection}
                                selectionMode={SelectionMode.none}
                                selectionPreservedOnEmptyClick={true}
                                onRenderItemColumn={this.renderItemColumn}
                                ariaLabelForSelectionColumn="Toggle selection"
                                ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                checkButtonAriaLabel="select row"
                                onItemInvoked={this._onItemInvoked}
                                onRenderDetailsHeader={(headerProps, defaultRender) => {
                                    return defaultRender({
                                        ...headerProps,
                                        styles: {
                                            root: {
                                                selectors: {
                                                    '.ms-DetailsHeader-cell': {
                                                        whiteSpace: 'normal',
                                                        textOverflow: 'clip',
                                                        lineHeight: 'normal',
                                                    },
                                                    '.ms-DetailsHeader-cellTitle': {
                                                        height: '100%',
                                                        alignItems: 'center',
                                                    },
                                                },
                                            }
                                        }
                                    })
                                }}
                            />
                        </StackItem>
                        <StackItem>
                            <Dialog
                                hidden={this.state.downloadFilesModalHidden}
                                onDismiss={this.DownloadableDocumentsDismissed}
                                dialogContentProps={{
                                    type: DialogType.normal,
                                    title: 'View Submitted Documents',
                                    subText: 'View Submitted documents associated with this Referral.'
                                }}
                                minWidth="45%"
                                modalProps={{
                                    isBlocking: true, styles: { main: {} }, dragOptions: {
                                        moveMenuItemText: 'Move',
                                        closeMenuItemText: 'Close',
                                        menu: ContextualMenu,
                                    }
                                }}>
                                <Stack>
                                    <StackItem hidden={this.state.downloadableFilesLoaderHidden}>
                                        <Spinner label="Loading Documents ..." ariaLive="assertive" labelPosition="right" />
                                    </StackItem>
                                    <StackItem>
                                        <DetailsList
                                            items={this.state.downloadableFiles}
                                            columns={_downloadabledocumentColumns}
                                            setKey="recordIndex"
                                            layoutMode={DetailsListLayoutMode.justified}
                                            selectionMode={SelectionMode.none}
                                            onRenderItemColumn={this.renderDownloadableDocumentColumn}
                                            onItemInvoked={this._onItemInvoked}
                                            onRenderDetailsHeader={(headerProps, defaultRender) => {
                                                return defaultRender({
                                                    ...headerProps,
                                                    styles: {
                                                        root: {
                                                            selectors: {
                                                                '.ms-DetailsHeader-cell': {
                                                                    whiteSpace: 'normal',
                                                                    textOverflow: 'clip',
                                                                    lineHeight: 'normal',
                                                                },
                                                                '.ms-DetailsHeader-cellTitle': {
                                                                    height: '100%',
                                                                    alignItems: 'center',
                                                                },
                                                            },
                                                        }
                                                    }
                                                })
                                            }}
                                        />
                                    </StackItem>
                                </Stack>
                                <DialogFooter>
                                    <PrimaryButton styles={{ root: { display: this.state.downloadFilesModalHidden == true ? "none" : "" } }} onClick={this.DownloadableDocumentsDismissed} text="Close" />
                                </DialogFooter>
                            </Dialog>
                        </StackItem>
                    </Stack>
                </div>
                <StackItem>
                    &nbsp;
                </StackItem>
                <StackItem>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px", display: this.state.user != undefined && this.state.user?.isReferral == true ? "block" : "none" }}>
                        <sub>Having issues with this page, please contact us for help at <a href="mailto:adrreferrals@fmcs.gov">adrreferrals@fmcs.gov</a>, or call (202) 606-5445.</sub>
                    </div>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px", display: this.state.user != undefined && this.state.user?.isReferral == false ? "block" : "none" }}>
                        <sub>Having issues with this page, please contact us for help at <a href="mailto:F7Notice@fmcs.gov">F7Notice@fmcs.gov</a>, or call us at (202) 606-5499.<br />
                            Have questions about our Services, please contact us for more information at <a href="mailto:ClientServices@fmcs.gov">ClientServices@fmcs.gov</a> or call us at 202-606-5499
                        </sub>
                    </div>
                </StackItem>
            </div>
        )
    }
}